const serifFont = "Recife Text, serif"
const sansSerifFont = "GT America, sans-serif"

const getFontsByProps = ({ serif = false, highlight = false }) => {
  const shouldBeSerif = serif || highlight
  return shouldBeSerif ? serifFont : sansSerifFont
}

export default getFontsByProps
